export default __webpack_public_path__ + "static/logo_var_orange_2_game_jam-6f135172e78e37029afd4aa18854961a.png";